// File: src/components/RequireAuth.tsx
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { Loader2 } from 'lucide-react'; // <<<< ENSURE THIS IMPORT IS PRESENT

interface RequireAuthProps {
  children: JSX.Element;
  requireStaff?: boolean;
}

export function RequireAuth({ children, requireStaff = false }: RequireAuthProps) {
  const { isAuthenticated, isLoadingUser, user } = useAuthStore();
  const location = useLocation();

  if (isLoadingUser) {
    // This is where Loader2 would be used
    return (
      <div className="flex items-center justify-center h-screen bg-secondary-50">
        <div className="flex flex-col items-center">
          <Loader2 className="h-10 w-10 text-primary-600 animate-spin mb-3" />
          <p className="text-secondary-700 font-medium">Loading session...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check staff requirement
  if (requireStaff && (!user || !user.is_staff)) {
    return (
      <div className="flex items-center justify-center h-screen bg-secondary-50">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-secondary-900 mb-2">Access Denied</h2>
          <p className="text-secondary-700">This page is restricted to staff members only.</p>
        </div>
      </div>
    );
  }

  return children;
}
